import "./Form.scss";
import React, { useState, useMemo } from "react";
import { Select } from "../../components";
import { parseTime } from "../../utilities";
import { SelectPremise } from "./SelectPremise";
import { useInspectors } from "./hooks/useInspectors";

const GENERAL_FIELDS = [
  ["premisesApartmentNumber", "text", "Apartment Number"],
  ["letterDate", "date", "Letter date"],
  ["inspectionDate", "date", "Inspection date"],
  ["samplesTaken", "text", "Samples Taken"],
];

const PREMISES_FIELDS = [
  ["premisesCorporationName", "text", "Corporation Name"],
  ["premisesCorporationAddress", "text", "Corporation Address"],
  ["premisesCorporationCity", "text", "Corporation City"],
  ["premisesCorporationState", "text", "Corporation State"],
  ["premisesCorporationZip", "text", "Corporation Zip"],
  ["premisesAddress", "text", "Address"],
  ["premisesCity", "text", "City"],
  ["premisesState", "text", "State", "NY"],
  ["premisesZip", "text", "ZIP Code"],
];

const INSPECTOR_FIELDS = [
  ["inspectorName", "select", "Inspector name"],
  ["certificationNumber", "text", "Certification #"],
  ["certificationExpirationDate", "date", "Certification Expiration Date"],
  ["firmName", "text", "Firm name", "RAZA ENVIRONMENTAL INC."],
];

const getInitialState = () => {
  return [...GENERAL_FIELDS, ...PREMISES_FIELDS, ...INSPECTOR_FIELDS].reduce(
    (acc, field) => {
      const [key, , , value = ""] = field;

      acc[key] = value;

      return acc;
    },
    {}
  );
};

export const DustWipeForm = ({ onCreate }) => {
  const [state, setState] = useState(getInitialState());
  const { inspectorsByName, inspectorsInputName } = useInspectors();

  const inspectorFields = useMemo(() => {
    if (!inspectorsInputName) {
      return INSPECTOR_FIELDS;
    }

    return INSPECTOR_FIELDS.map((curr) => {
      const [key] = curr;

      if (key === "inspectorName") {
        return [...curr, inspectorsInputName];
      }

      return curr;
    });
  }, [inspectorsInputName]);

  const onChange = (event) => {
    const key = event.target.name;
    const value = key.match("startTime|endTime")
      ? parseTime(event.target.value)
      : event.target.value;

    setState({
      ...state,
      [key]: value,
    });
  };

  const onSelect = (event) => {
    const key = event.target.name;

    if (key === "inspectorName") {
      const inspectorName = event.target.value;

      const inspectorInfo = inspectorsByName[inspectorName] || {};

      setState({
        ...state,
        inspectorName,
        ...inspectorInfo,
      });
      return;
    }

    setState({
      ...state,
      [key]: event.target.value,
    });
  };

  const onClear = () => {
    setState(getInitialState());
  };

  const onSubmit = () => {
    const fields = Object.keys(state).reduce((acc, key) => {
      if (key.match("letterDate|inspectionDate|certificationExpirationDate")) {
        const [year, month, day] = state[key].split("-");
        acc[key] = month + "/" + day + "/" + year;
      } else {
        acc[key] = state[key];
      }

      return acc;
    }, {});

    onCreate({
      fields,
      type: "dust-wipe",
    });
  };

  const onSelectPremise = (premise) => {
    setState((currentState) => ({
      ...currentState,
      premisesAddress: premise.address,
      premisesCity: premise.city,
      premisesState: premise.state,
      premisesZip: premise.zip,
      premisesCorporationName: premise.corporationName,
      premisesCorporationAddress: premise.corporationAddress,
      premisesCorporationCity: premise.corporationCity,
      premisesCorporationState: premise.corporationState,
      premisesCorporationZip: premise.corporationZip,
    }));
  };

  return (
    <div className="create-documents-form">
      <div className="create-documents-form-group">
        <div className="group-label">
          <h4>Client</h4>
        </div>
        <SelectPremise onSelectPremise={onSelectPremise} />
      </div>

      <div className="create-documents-form-group">
        <div className="group-label">
          <h4>General</h4>
        </div>
        <Fields fields={GENERAL_FIELDS} state={state} onChange={onChange} />
      </div>

      <div className="create-documents-form-group">
        <div className="group-label">
          <h4>Premises</h4>
        </div>
        <Fields fields={PREMISES_FIELDS} state={state} onChange={onChange} />
      </div>

      <div className="create-documents-form-group">
        <div className="group-label">
          <h4>Inspector</h4>
        </div>
        <Fields
          fields={inspectorFields}
          state={state}
          onChange={onChange}
          onSelect={onSelect}
        />
      </div>

      <div className="create-documents-form-buttons">
        <button onClick={onClear}>Clear</button>
        <button onClick={onSubmit} className="create">
          Create
        </button>
      </div>
    </div>
  );
};

const Fields = ({ fields, state, onChange, onSelect }) => {
  return (
    <div className="group-fields">
      {fields.map((field, idx) => {
        const [name, type, placeholder, options] = field;
        const key = field + "-" + idx;

        if (type === "select") {
          return (
            <div key={key} className="field">
              <Select
                name={name}
                label={placeholder}
                value={state[name]}
                options={options}
                onChange={onSelect}
                className="inline-select"
              />
            </div>
          );
        }

        return (
          <div key={key} className="field">
            <label htmlFor={name}>{placeholder}</label>
            <input
              value={state[name]}
              name={name}
              type={type}
              onChange={onChange}
            />
          </div>
        );
      })}
    </div>
  );
};
